import { StyledIconButton } from './IconButton.styles';

export default StyledIconButton;
